import { pickBy as lo_pickBy } from 'es-toolkit';

export function objFilterNulls<T = any>(obj: any): any {
    return lo_pickBy<any>(obj || {}, (val) => val) as T;
}
